import React, { useState } from "react";
import axios from "axios";
import "./Contact.css";

const DropAMessage = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [status, setStatus] = useState("");  // To track submission status
  const [animationClass, setAnimationClass] = useState("");  // To add animations
  const [showPopup, setShowPopup] = useState(false); // To show success popup

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateEmail(formData.email)) {
      alert("Bitte geben Sie eine gültige E-Mail-Adresse ein.");
      return;
    }

    setStatus("sending");
    setAnimationClass("animate");

    const data = {
      from: `${formData.name} <${formData.email}>`,
      to: "yassarhammami@gmail.com", // Change this to your email
      subject: "New Contact Form Submission",
      text: `Name: ${formData.name}\nEmail: ${formData.email}\nMessage: ${formData.message}`,
    };

    const config = {
      headers: {
        "Authorization": `Basic ${btoa(`api:${process.env.REACT_APP_MAILGUN_API_KEY}`)}`,
        "Content-Type": "application/x-www-form-urlencoded",
      },
    };

    axios
      .post(`https://api.mailgun.net/v3/sandbox0df7d3f8fcb846b8a42813008516e773.mailgun.org/messages`, new URLSearchParams(data).toString(), config)
      .then((response) => {
        setStatus("success");
        setAnimationClass("animate-success");
        setFormData({ name: "", email: "", message: "" });
        setShowPopup(true);
      })
      .catch((error) => {
        setStatus("error");
        setAnimationClass("animate-error");
        console.error("Beim Senden der Nachricht ist ein Fehler aufgetreten.", error);
        setTimeout(() => setStatus(""), 3000);  // Clear status after 3 seconds
      });
  };

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  return (
    <div className={`form-container ${animationClass}`}>
      <div className="py-2">
        <h1 className="text-4xl font-bold font-Roboto">
          Senden Sie uns eine <span className="text-primary">Nachricht</span>
        </h1>
        <p className="text-gray-400 py-2">
          Haben Sie eine Frage oder möchten Sie einfach nur Hallo sagen? Wir würden uns freuen, von Ihnen zu hören.
        </p>
      </div>
      {status && (
        <div className={`status-message ${status}`}>
          {status === "sending" && "Senden..."}
          {status === "success" && "Nachricht erfolgreich gesendet!"}
          {status === "error" && "Beim Senden der Nachricht ist ein Fehler aufgetreten."}
        </div>
      )}
      {showPopup && (
        <div className="overlay">
          <div className="popup animate-popup">
            <p>Vielen Dank für Ihre Nachricht! Wir werden uns so schnell wie möglich mit Ihnen in Verbindung setzen.</p>
            <button className="ok-button" onClick={handleClosePopup}>OK</button>
          </div>
        </div>
      )}
      <form onSubmit={handleSubmit}>
        <fieldset>
          <label htmlFor="name">Vollständiger Name:</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Geben Sie Ihren vollständigen Namen ein"
            required
          />
          <label htmlFor="email">Email:</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Geben Sie Ihre E-Mail-Adresse ein"
            required
          />
          <label htmlFor="message">Nachricht:</label>
          <textarea
            id="message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            rows="4"
            placeholder="Geben Sie hier Ihre Nachricht ein"
            required
          ></textarea>
          <button type="submit">Schicken</button>
        </fieldset>
      </form>
    </div>
  );
};

export default DropAMessage;
